var GameTheme;
(function (GameTheme) {
    GameTheme[GameTheme["Standart"] = 0] = "Standart";
    GameTheme[GameTheme["Winter"] = 1] = "Winter";
    GameTheme[GameTheme["Halloween"] = 2] = "Halloween";
    GameTheme[GameTheme["Football"] = 3] = "Football";
    GameTheme[GameTheme["Valentine"] = 4] = "Valentine";
})(GameTheme || (GameTheme = {}));
var GameThemeNames = {
    Standart: 'Standart',
    Winter: 'Winter',
    Halloween: 'Halloween',
    Football: 'Football',
    Valentine: 'Valentine',
};
var GameThemeTKeys = {
    Standart: 'STANDART_MODE',
    Winter: 'WINTER_MODE',
    Halloween: 'HALLOWEEN_MODE',
    Football: 'FOOTBALL_MODE',
    Valentine: 'VALENTINE_MODE',
};

export { GameTheme, GameThemeNames, GameThemeTKeys };
